const swiperHero = new Swiper('.swiper-hero-slider', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    loop: true,
    watchOverflow: true,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination-hero',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-hero',
      prevEl: '.swiper-button-prev-hero',
    },
    // Enable touch on mobile/tablet, disable on desktop
    allowTouchMove: window.innerWidth < 769,
    
    // Critical: Don't prevent clicks on links/buttons
    preventClicks: false,
    preventClicksPropagation: false,
    
    // Require 5px movement before it's considered a swipe (helps buttons work on mobile)
    threshold: 5,
    
    // Better touch behavior for mobile/tablet
    touchRatio: 1,
    touchAngle: 45,
    resistanceRatio: 0.85,
});